export default {
    namespaced:  true,
    state: {
        isChatbotOpen: false
    },
    getters: {
        isChatbotOpen: state => {
            return state.isChatbotOpen;
        }
    },
    mutations: {
        openChatbot: state => {
            state.isChatbotOpen = true;
        },
        closeChatbot: state => {
            state.isChatbotOpen = false;
        }
    }
}